<du-lipo-overview [overviewModel]="licenseOverviewModel"></du-lipo-overview>
